<template>
    <div class="qwen_ai_header">
        <div class="header_left">
            <span>初新插件</span>
            <span> / </span>
            <span>{{ menuName }}</span>
        </div>
        <div class="header_right">
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const menuName = ref(null);

watch(() => route.meta.title, (newTitle) => {
    menuName.value = newTitle;
    console.log(menuName.value);
    console.log("*********888888*********")
}, { immediate: true });
</script>

<style lang="scss">
.qwen_ai_header {
    height: 68px;
    padding: 0 16px;
    background: #f9fafdeb;
    border-bottom: 1px solid #e8eaf0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .header_left {
        color: #999;
        font-size: 14px;
        font-weight: 400;
    }

    .header_right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 8px;
        font-size: 13px;

        .button_row {
            padding: 8px 13px;
            border-radius: 8px;
            color: #676d78;
            cursor: pointer;
        }

        .share_button {
            padding: 8px 13px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
            background: #edf4ff;
            color: #3976f6;
            border: 1px solid #e1ebff;
            border-radius: 8px;
            cursor: pointer;
        }
    }
}
</style>